export default {
  common: {
    siteName: 'Yisu Cloud User Center',
    units: {
      vCoreSingle: 'vCore',
      vCoreComplex: 'vCores',
    },
    list: {
      searchButton: 'Search',
      location: 'Location',
      areaAll: 'All',
      columnAction: 'Actions',
      purchase: 'Purchase',
    },
    modal: {
      charge: 'Charges',
      done: 'Done',
      confirm: 'Confirm',
      cancel: 'Cancel',
      delete: 'Delete',
      pay: 'Pay'
    },
    monthUnit: 'Mons',
    yearUnit: 'Year',
    singleMonth: 'mo',
    periodSelect: {
      '1h': '1 Hours',
      '1d': '1 Day',
      '1w': '1 Week',
      '1m': '1 Month',
    },
    // 付款组件
    payComp: {
      balance: 'Balance',
      methods: {
        header: 'Payment Method:',
        unionPay: 'UnionPay',
        paypal: 'PayPal',
        alipay: 'Alipay',
        wechatPay: 'WechatPay',
        strip: 'Strip',
        creditCard: 'Credit Card'
      },
      addPaymentMethod: 'Add Payment Method',
      expires: '过期时间',
      default: '默认',
      expiresSoon: '即将过期',
      password: {header: 'Password:', placeholder: 'Please enter the login password'}
    },
    // 顶栏
    topBar: {
      accountBalance: 'Account Balance',
      addFunds: 'Add Funds',
      billingHistory: 'Billing History',
      orders: 'Orders',
      accountId: 'Account ID',
      logout: 'Logout'
    },
    message : {
      warning: 'Warning',
      ok: 'OK',
      sessionExpired: 'Your session has expired. Please log in again.',
      requestExpired: 'Your request has expired. Please refresh the page.',
      logoutSuccess: 'Logout Success',
      copySuccess: "Copy Success",
      copyFail: "Copy Fail",
    },
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/common.js